/**
 * The icon registry: Material Symbols Rounded, weight 400, 24 dp (PRD section 16).
 *
 * Only the icons listed here are bundled, as raw SVG strings (`?raw`), so the app
 * never ships the multi-megabyte icon font. To add one, find its file name in
 * node_modules/@material-symbols/svg-400/rounded/ and import it below.
 */
import add from '@material-symbols/svg-400/rounded/add.svg?raw'
import arrowDownward from '@material-symbols/svg-400/rounded/arrow_downward.svg?raw'
import arrowForward from '@material-symbols/svg-400/rounded/arrow_forward.svg?raw'
import arrowUpward from '@material-symbols/svg-400/rounded/arrow_upward.svg?raw'
import backspace from '@material-symbols/svg-400/rounded/backspace.svg?raw'
import calculate from '@material-symbols/svg-400/rounded/calculate.svg?raw'
import check from '@material-symbols/svg-400/rounded/check.svg?raw'
import checkCircle from '@material-symbols/svg-400/rounded/check_circle.svg?raw'
import close from '@material-symbols/svg-400/rounded/close.svg?raw'
import cloudOff from '@material-symbols/svg-400/rounded/cloud_off.svg?raw'
import compareArrows from '@material-symbols/svg-400/rounded/compare_arrows.svg?raw'
import contrast from '@material-symbols/svg-400/rounded/contrast.svg?raw'
import darkMode from '@material-symbols/svg-400/rounded/dark_mode.svg?raw'
import deleteIcon from '@material-symbols/svg-400/rounded/delete.svg?raw'
import description from '@material-symbols/svg-400/rounded/description.svg?raw'
import download from '@material-symbols/svg-400/rounded/download.svg?raw'
import editNote from '@material-symbols/svg-400/rounded/edit_note.svg?raw'
import error from '@material-symbols/svg-400/rounded/error.svg?raw'
import groups from '@material-symbols/svg-400/rounded/groups.svg?raw'
import home from '@material-symbols/svg-400/rounded/home.svg?raw'
import inbox from '@material-symbols/svg-400/rounded/inbox.svg?raw'
import info from '@material-symbols/svg-400/rounded/info.svg?raw'
import keyboardArrowDown from '@material-symbols/svg-400/rounded/keyboard_arrow_down.svg?raw'
import lightMode from '@material-symbols/svg-400/rounded/light_mode.svg?raw'
import lock from '@material-symbols/svg-400/rounded/lock.svg?raw'
import pictureAsPdf from '@material-symbols/svg-400/rounded/picture_as_pdf.svg?raw'
import print from '@material-symbols/svg-400/rounded/print.svg?raw'
import refresh from '@material-symbols/svg-400/rounded/refresh.svg?raw'
import savings from '@material-symbols/svg-400/rounded/savings.svg?raw'
import schedule from '@material-symbols/svg-400/rounded/schedule.svg?raw'
import uploadFile from '@material-symbols/svg-400/rounded/upload_file.svg?raw'
import warning from '@material-symbols/svg-400/rounded/warning.svg?raw'

import accountBalanceIcon from '@material-symbols/svg-400/rounded/account_balance.svg?raw'
import accountBalanceWalletIcon from '@material-symbols/svg-400/rounded/account_balance_wallet.svg?raw'
import arrowBackIcon from '@material-symbols/svg-400/rounded/arrow_back.svg?raw'
import cancelIcon from '@material-symbols/svg-400/rounded/cancel.svg?raw'
import celebrationIcon from '@material-symbols/svg-400/rounded/celebration.svg?raw'
import chevronRightIcon from '@material-symbols/svg-400/rounded/chevron_right.svg?raw'
import contentCopyIcon from '@material-symbols/svg-400/rounded/content_copy.svg?raw'
import dashboardIcon from '@material-symbols/svg-400/rounded/dashboard.svg?raw'
import doneAllIcon from '@material-symbols/svg-400/rounded/done_all.svg?raw'
import editIcon from '@material-symbols/svg-400/rounded/edit.svg?raw'
import eventIcon from '@material-symbols/svg-400/rounded/event.svg?raw'
import factCheckIcon from '@material-symbols/svg-400/rounded/fact_check.svg?raw'
import gavelIcon from '@material-symbols/svg-400/rounded/gavel.svg?raw'
import groupIcon from '@material-symbols/svg-400/rounded/group.svg?raw'
import handshakeIcon from '@material-symbols/svg-400/rounded/handshake.svg?raw'
import historyIcon from '@material-symbols/svg-400/rounded/history.svg?raw'
import hourglassTopIcon from '@material-symbols/svg-400/rounded/hourglass_top.svg?raw'
import languageIcon from '@material-symbols/svg-400/rounded/language.svg?raw'
import logoutIcon from '@material-symbols/svg-400/rounded/logout.svg?raw'
import monitoringIcon from '@material-symbols/svg-400/rounded/monitoring.svg?raw'
import moreHorizIcon from '@material-symbols/svg-400/rounded/more_horiz.svg?raw'
import notificationsIcon from '@material-symbols/svg-400/rounded/notifications.svg?raw'
import paymentsIcon from '@material-symbols/svg-400/rounded/payments.svg?raw'
import pendingActionsIcon from '@material-symbols/svg-400/rounded/pending_actions.svg?raw'
import personIcon from '@material-symbols/svg-400/rounded/person.svg?raw'
import qrCodeIcon from '@material-symbols/svg-400/rounded/qr_code.svg?raw'
import receiptLongIcon from '@material-symbols/svg-400/rounded/receipt_long.svg?raw'
import requestQuoteIcon from '@material-symbols/svg-400/rounded/request_quote.svg?raw'
import ruleIcon from '@material-symbols/svg-400/rounded/rule.svg?raw'
import searchIcon from '@material-symbols/svg-400/rounded/search.svg?raw'
import sendIcon from '@material-symbols/svg-400/rounded/send.svg?raw'
import shieldIcon from '@material-symbols/svg-400/rounded/shield.svg?raw'
import smsIcon from '@material-symbols/svg-400/rounded/sms.svg?raw'
import swapHorizIcon from '@material-symbols/svg-400/rounded/swap_horiz.svg?raw'
import tableViewIcon from '@material-symbols/svg-400/rounded/table_view.svg?raw'
import taskAltIcon from '@material-symbols/svg-400/rounded/task_alt.svg?raw'
import verifiedIcon from '@material-symbols/svg-400/rounded/verified.svg?raw'
import visibilityIcon from '@material-symbols/svg-400/rounded/visibility.svg?raw'
import bugReportIcon from '@material-symbols/svg-400/rounded/bug_report.svg?raw'
import fastForwardIcon from '@material-symbols/svg-400/rounded/fast_forward.svg?raw'
import playArrowIcon from '@material-symbols/svg-400/rounded/play_arrow.svg?raw'
import undoIcon from '@material-symbols/svg-400/rounded/undo.svg?raw'
import blockIcon from '@material-symbols/svg-400/rounded/block.svg?raw'
import personAddIcon from '@material-symbols/svg-400/rounded/person_add.svg?raw'
import keyIcon from '@material-symbols/svg-400/rounded/key.svg?raw'
import accountCircleIcon from '@material-symbols/svg-400/rounded/account_circle.svg?raw'
import flagIcon from '@material-symbols/svg-400/rounded/flag.svg?raw'
import timerIcon from '@material-symbols/svg-400/rounded/timer.svg?raw'
import unfoldMoreIcon from '@material-symbols/svg-400/rounded/unfold_more.svg?raw'
import helpIcon from '@material-symbols/svg-400/rounded/help.svg?raw'
import chatIcon from '@material-symbols/svg-400/rounded/chat.svg?raw'
import forumIcon from '@material-symbols/svg-400/rounded/forum.svg?raw'
import calendarMonthIcon from '@material-symbols/svg-400/rounded/calendar_month.svg?raw'
import trendingUpIcon from '@material-symbols/svg-400/rounded/trending_up.svg?raw'
import creditCardIcon from '@material-symbols/svg-400/rounded/credit_card.svg?raw'
import photoCameraIcon from '@material-symbols/svg-400/rounded/photo_camera.svg?raw'
import attachFileIcon from '@material-symbols/svg-400/rounded/attach_file.svg?raw'
import filterListIcon from '@material-symbols/svg-400/rounded/filter_list.svg?raw'
import sortIcon from '@material-symbols/svg-400/rounded/sort.svg?raw'
import checklistIcon from '@material-symbols/svg-400/rounded/checklist.svg?raw'
import balanceIcon from '@material-symbols/svg-400/rounded/balance.svg?raw'
import reportIcon from '@material-symbols/svg-400/rounded/report.svg?raw'
import priorityHighIcon from '@material-symbols/svg-400/rounded/priority_high.svg?raw'
import lockOpenIcon from '@material-symbols/svg-400/rounded/lock_open.svg?raw'
import openInNewIcon from '@material-symbols/svg-400/rounded/open_in_new.svg?raw'
import syncIcon from '@material-symbols/svg-400/rounded/sync.svg?raw'
import linkIcon from '@material-symbols/svg-400/rounded/link.svg?raw'
import listIcon from '@material-symbols/svg-400/rounded/list.svg?raw'
import tuneIcon from '@material-symbols/svg-400/rounded/tune.svg?raw'
import toggleOnIcon from '@material-symbols/svg-400/rounded/toggle_on.svg?raw'
import toggleOffIcon from '@material-symbols/svg-400/rounded/toggle_off.svg?raw'
import mailIcon from '@material-symbols/svg-400/rounded/mail.svg?raw'
import mobileIcon from '@material-symbols/svg-400/rounded/mobile.svg?raw'
import uploadIcon from '@material-symbols/svg-400/rounded/upload.svg?raw'
import keyboardArrowUpIcon from '@material-symbols/svg-400/rounded/keyboard_arrow_up.svg?raw'
import keyboardArrowRightIcon from '@material-symbols/svg-400/rounded/keyboard_arrow_right.svg?raw'
// Officer and console screens (features/officer).
import volunteerActivismIcon from '@material-symbols/svg-400/rounded/volunteer_activism.svg?raw'
import inventory2Icon from '@material-symbols/svg-400/rounded/inventory_2.svg?raw'
import personRemoveIcon from '@material-symbols/svg-400/rounded/person_remove.svg?raw'
import trendingDownIcon from '@material-symbols/svg-400/rounded/trending_down.svg?raw'
import healthAndSafetyIcon from '@material-symbols/svg-400/rounded/health_and_safety.svg?raw'
import barChartIcon from '@material-symbols/svg-400/rounded/bar_chart.svg?raw'
import badgeIcon from '@material-symbols/svg-400/rounded/badge.svg?raw'
import howToRegIcon from '@material-symbols/svg-400/rounded/how_to_reg.svg?raw'
import lightbulbIcon from '@material-symbols/svg-400/rounded/lightbulb.svg?raw'
import callIcon from '@material-symbols/svg-400/rounded/call.svg?raw'
import doNotDisturbOnIcon from '@material-symbols/svg-400/rounded/do_not_disturb_on.svg?raw'
import southWestIcon from '@material-symbols/svg-400/rounded/south_west.svg?raw'
import northEastIcon from '@material-symbols/svg-400/rounded/north_east.svg?raw'
import pendingIcon from '@material-symbols/svg-400/rounded/pending.svg?raw'
import speedIcon from '@material-symbols/svg-400/rounded/speed.svg?raw'
import verifiedUserIcon from '@material-symbols/svg-400/rounded/verified_user.svg?raw'
import editCalendarIcon from '@material-symbols/svg-400/rounded/edit_calendar.svg?raw'
import groupAddIcon from '@material-symbols/svg-400/rounded/group_add.svg?raw'
// Member screens (features/member).
import eventRepeatIcon from '@material-symbols/svg-400/rounded/event_repeat.svg?raw'
import lockResetIcon from '@material-symbols/svg-400/rounded/lock_reset.svg?raw'
import personSearchIcon from '@material-symbols/svg-400/rounded/person_search.svg?raw'
import doorOpenIcon from '@material-symbols/svg-400/rounded/door_open.svg?raw'
import paidIcon from '@material-symbols/svg-400/rounded/paid.svg?raw'
// Signed-in phones (app/DevicesPage).
import computerIcon from '@material-symbols/svg-400/rounded/computer.svg?raw'

export const icons = {
  add,
  arrow_downward: arrowDownward,
  arrow_forward: arrowForward,
  arrow_upward: arrowUpward,
  backspace,
  calculate,
  check,
  check_circle: checkCircle,
  close,
  cloud_off: cloudOff,
  compare_arrows: compareArrows,
  contrast,
  dark_mode: darkMode,
  delete: deleteIcon,
  description,
  download,
  edit_note: editNote,
  error,
  groups,
  home,
  inbox,
  info,
  keyboard_arrow_down: keyboardArrowDown,
  light_mode: lightMode,
  lock,
  picture_as_pdf: pictureAsPdf,
  print,
  refresh,
  savings,
  schedule,
  upload_file: uploadFile,
  warning,
  account_balance: accountBalanceIcon,
  account_balance_wallet: accountBalanceWalletIcon,
  arrow_back: arrowBackIcon,
  cancel: cancelIcon,
  celebration: celebrationIcon,
  chevron_right: chevronRightIcon,
  content_copy: contentCopyIcon,
  dashboard: dashboardIcon,
  done_all: doneAllIcon,
  edit: editIcon,
  event: eventIcon,
  fact_check: factCheckIcon,
  gavel: gavelIcon,
  group: groupIcon,
  handshake: handshakeIcon,
  history: historyIcon,
  hourglass_top: hourglassTopIcon,
  language: languageIcon,
  logout: logoutIcon,
  monitoring: monitoringIcon,
  more_horiz: moreHorizIcon,
  notifications: notificationsIcon,
  payments: paymentsIcon,
  pending_actions: pendingActionsIcon,
  person: personIcon,
  qr_code: qrCodeIcon,
  receipt_long: receiptLongIcon,
  request_quote: requestQuoteIcon,
  rule: ruleIcon,
  search: searchIcon,
  send: sendIcon,
  shield: shieldIcon,
  sms: smsIcon,
  swap_horiz: swapHorizIcon,
  table_view: tableViewIcon,
  task_alt: taskAltIcon,
  verified: verifiedIcon,
  visibility: visibilityIcon,
  bug_report: bugReportIcon,
  fast_forward: fastForwardIcon,
  play_arrow: playArrowIcon,
  undo: undoIcon,
  block: blockIcon,
  person_add: personAddIcon,
  key: keyIcon,
  account_circle: accountCircleIcon,
  flag: flagIcon,
  timer: timerIcon,
  unfold_more: unfoldMoreIcon,
  help: helpIcon,
  chat: chatIcon,
  forum: forumIcon,
  calendar_month: calendarMonthIcon,
  trending_up: trendingUpIcon,
  credit_card: creditCardIcon,
  photo_camera: photoCameraIcon,
  attach_file: attachFileIcon,
  filter_list: filterListIcon,
  sort: sortIcon,
  checklist: checklistIcon,
  balance: balanceIcon,
  report: reportIcon,
  priority_high: priorityHighIcon,
  lock_open: lockOpenIcon,
  open_in_new: openInNewIcon,
  sync: syncIcon,
  link: linkIcon,
  list: listIcon,
  tune: tuneIcon,
  toggle_on: toggleOnIcon,
  toggle_off: toggleOffIcon,
  mail: mailIcon,
  upload: uploadIcon,
  keyboard_arrow_up: keyboardArrowUpIcon,
  keyboard_arrow_right: keyboardArrowRightIcon,
  mobile: mobileIcon,
  volunteer_activism: volunteerActivismIcon,
  inventory_2: inventory2Icon,
  person_remove: personRemoveIcon,
  trending_down: trendingDownIcon,
  health_and_safety: healthAndSafetyIcon,
  bar_chart: barChartIcon,
  badge: badgeIcon,
  how_to_reg: howToRegIcon,
  lightbulb: lightbulbIcon,
  call: callIcon,
  do_not_disturb_on: doNotDisturbOnIcon,
  south_west: southWestIcon,
  north_east: northEastIcon,
  pending: pendingIcon,
  speed: speedIcon,
  verified_user: verifiedUserIcon,
  edit_calendar: editCalendarIcon,
  group_add: groupAddIcon,
  event_repeat: eventRepeatIcon,
  lock_reset: lockResetIcon,
  person_search: personSearchIcon,
  door_open: doorOpenIcon,
  paid: paidIcon,
  computer: computerIcon,
} as const

export type IconName = keyof typeof icons
